var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-10"},_vm._l((_vm.items),function(item){return _c('TreeViewItem',{key:item.id,attrs:{"name":_vm.name,"item":item},on:{"selected":_vm.handle}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }